import React, { useMemo } from "react";
import {
    LinkControllerContext,
    type LinkControllerContextValue,
} from "../../state/link-controller.context";

interface LinkControllerProps {
    children: React.ReactNode;
    suppress?: string;
    layout?: string;
    activateToggleSwitch?: string;
}

/**
 * Supplies optional default `suppress`, `layout`, and `activateToggleSwitch` for descendant `AppLink`
 * components. Nearest controller wins; explicit `AppLink` props override per property.
 */
export function LinkController({
    children,
    suppress,
    layout,
    activateToggleSwitch,
}: LinkControllerProps): JSX.Element {
    const value = useMemo((): LinkControllerContextValue => {
        const next: LinkControllerContextValue = {};
        if (suppress !== undefined) {
            next.suppress = suppress;
        }
        if (layout !== undefined) {
            next.layout = layout;
        }
        if (activateToggleSwitch !== undefined) {
            next.activateToggleSwitch = activateToggleSwitch;
        }
        return next;
    }, [suppress, layout, activateToggleSwitch]);

    return <LinkControllerContext.Provider value={value}>{children}</LinkControllerContext.Provider>;
}
